export const MAX_BED = 100;
